import { takeEvery, call, put, all } from 'redux-saga/effects';
import {
    FETCH_PERSONAL_RECORDS,
    FETCH_PERSONAL_RECORDS_FETCHING,
    FETCH_PERSONAL_RECORDS_SUCCESS,
    FETCH_PERSONAL_RECORDS_FAIL,
    FETCH_PERSONAL_RECORD_CANDIDATES,
    FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING,
    FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS,
    FETCH_PERSONAL_RECORD_CANDIDATES_FAIL,
    FETCH_PERSONAL_RECORD_TYPES,
    FETCH_PERSONAL_RECORD_TYPES_FETCHING,
    FETCH_PERSONAL_RECORD_TYPES_SUCCESS,
    FETCH_PERSONAL_RECORD_TYPES_FAIL,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL,
    UPDATE_PERSONAL_RECORD_TYPE,
    UPDATE_PERSONAL_RECORD_TYPE_FAIL,
    DELETE_PERSONAL_RECORD,
    DELETE_PERSONAL_RECORD_SUCCESS,
    DELETE_PERSONAL_RECORD_FAIL,
    DELETE_PERSONAL_RECORD_CANDIDATE,
    DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS,
    DELETE_PERSONAL_RECORD_CANDIDATE_FAIL,
    ADD_PERSONAL_RECORD,
    ADD_PERSONAL_RECORD_SUCCESS,
    ADD_PERSONAL_RECORD_FAIL,
    UPDATE_PERSONAL_RECORD,
    UPDATE_PERSONAL_RECORD_SUCCESS,
    UPDATE_PERSONAL_RECORD_FAIL
} from 'actions/ActionTypes';
import { gcApi } from '../config/axios';

// Workers
export function* fetchPersonalRecordsSaga(action) {
    const { displayName } = action;

    try {
        yield put({
            type: FETCH_PERSONAL_RECORDS_FETCHING
        });

        const response = yield call(gcApi.get, `/personalrecord-service/personalrecord/prs/${displayName}`);

        yield put({
            type: FETCH_PERSONAL_RECORDS_SUCCESS,
            displayName: displayName,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PERSONAL_RECORDS_FAIL,
            displayName: displayName,
            data: null
        });
    }
}

export function* fetchPersonalRecordCandidatesSaga(action) {
    const { displayName } = action;

    try {
        yield put({
            type: FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING
        });

        const response = yield call(gcApi.get, `/personalrecord-service/personalrecordcandidate/${displayName}`);

        yield put({
            type: FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS,
            displayName: displayName,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PERSONAL_RECORD_CANDIDATES_FAIL,
            displayName: displayName,
            data: null
        });
    }
}

export function* fetchPersonalRecordTypesSaga(action) {
    const { displayName } = action;

    try {
        yield put({
            type: FETCH_PERSONAL_RECORD_TYPES_FETCHING
        });

        const response = yield call(gcApi.get, `/personalrecord-service/personalrecordtype/prtypes/${displayName}`);

        yield put({
            type: FETCH_PERSONAL_RECORD_TYPES_SUCCESS,
            displayName: displayName,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PERSONAL_RECORD_TYPES_FAIL,
            displayName: displayName,
            data: null
        });
    }
}

export function* fetchPersonalRecordByActivityIdSaga(action) {
    const { activityId } = action;

    try {
        yield put({
            type: FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING
        });

        const response = yield call(gcApi.get, `/personalrecord-service/personalrecord/prByActivityId/${activityId}`);

        yield put({
            type: FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS,
            activityId: activityId,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL,
            activityId: activityId,
            data: null
        });
    }
}

export function* updatePersonalRecordTypes(action) {
    const { recordType, displayName } = action;

    try {
        const response = yield call(
            gcApi.put,
            `/personalrecord-service/personalrecordtype/${recordType.id}`,
            recordType
        );

        yield call(fetchPersonalRecordTypesSaga, { displayName: displayName });
    } catch (e) {
        yield put({
            type: UPDATE_PERSONAL_RECORD_TYPE_FAIL
        });
    }
}

export function* deletePersonalRecord(action) {
    const { personalRecord, displayName } = action;

    try {
        const response = yield call(gcApi.delete, `/personalrecord-service/personalrecord/${personalRecord.id}`);

        yield call(fetchPersonalRecordsSaga, { displayName: displayName });

        yield put({
            type: DELETE_PERSONAL_RECORD_SUCCESS
        });
    } catch (e) {
        yield put({
            type: DELETE_PERSONAL_RECORD_FAIL
        });
    }
}

export function* deletePersonalRecordCandidate(action) {
    const { personalRecordCandidate, displayName } = action;

    try {
        const response = yield call(
            gcApi.delete,
            `/personalrecord-service/personalrecordcandidate/${personalRecordCandidate.id}`
        );

        yield call(fetchPersonalRecordCandidatesSaga, { displayName: displayName });

        yield put({
            type: DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS
        });
    } catch (e) {
        yield put({
            type: DELETE_PERSONAL_RECORD_CANDIDATE_FAIL
        });
    }
}

export function* addPersonalRecord(action) {
    const { personalRecord, displayName } = action;

    try {
        yield call(gcApi.put, '/personalrecord-service/personalrecord/', personalRecord);

        yield all([
            call(fetchPersonalRecordsSaga, { displayName: displayName }),
            call(fetchPersonalRecordCandidatesSaga, { displayName: displayName })
        ]);

        yield put({
            type: ADD_PERSONAL_RECORD_SUCCESS
        });
    } catch (e) {
        yield put({
            type: ADD_PERSONAL_RECORD_FAIL
        });
    }
}

export function* updatePersonalRecord(action) {
    const { personalRecord } = action;

    try {
        const response = yield call(
            gcApi.put,
            `/personalrecord-service/personalrecord/${personalRecord.id}`,
            personalRecord
        );

        yield put({
            type: UPDATE_PERSONAL_RECORD_SUCCESS
        });
    } catch (e) {
        yield put({
            type: UPDATE_PERSONAL_RECORD_FAIL
        });
    }
}

// Watchers
export const personalRecordsSagas = [
    takeEvery(FETCH_PERSONAL_RECORDS, fetchPersonalRecordsSaga),
    takeEvery(FETCH_PERSONAL_RECORD_CANDIDATES, fetchPersonalRecordCandidatesSaga),
    takeEvery(FETCH_PERSONAL_RECORD_TYPES, fetchPersonalRecordTypesSaga),
    takeEvery(FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID, fetchPersonalRecordByActivityIdSaga),
    takeEvery(UPDATE_PERSONAL_RECORD_TYPE, updatePersonalRecordTypes),
    takeEvery(DELETE_PERSONAL_RECORD, deletePersonalRecord),
    takeEvery(DELETE_PERSONAL_RECORD_CANDIDATE, deletePersonalRecordCandidate),
    takeEvery(ADD_PERSONAL_RECORD, addPersonalRecord),
    takeEvery(UPDATE_PERSONAL_RECORD, updatePersonalRecord)
];
